import { ReactNode, CSSProperties, forwardRef } from 'react';

type CardProps = {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
  style?: CSSProperties;
  tabIndex?: number;
  'data-testid'?: string;
};

const Card = forwardRef<HTMLDivElement, CardProps>(({ children, className = '', onClick, style, tabIndex, 'data-testid': dataTestId }, ref) => {
  return (
    <div ref={ref} data-testid={dataTestId} tabIndex={tabIndex} className={`rounded-rustic border border-wheat bg-linen/60 p-1 ${className}`} onClick={onClick} style={style}>
      {children}
    </div>
  );
});

Card.displayName = 'Card';

export default Card;
